import React from 'react';
import { useLocation } from 'react-router-dom';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { Site } from '@99designs/site-navigation/lib/Site';

const DOT_COM_DOMAIN = '99designs.com';

export default function DotComOnlyRoute({
    site,
    children,
}: {
    site: Site;
    children: React.ReactNode;
}) {
    const { pathname } = useLocation();
    if (site.getDomain() !== DOT_COM_DOMAIN) {
        window.location.replace(`https://${DOT_COM_DOMAIN}${pathname}`);
        return null;
    }
    return <>{children}</>;
}
